import { ReactNode, FC } from 'react';
import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';

const ArrowIcon = styled(SvgIcon)<{ color?: string; viewBoxWidth?: number }>`
  min-width: 25px;

  &.left {
    transform: rotate(180deg);
  }

  &.top {
    transform: rotate(-90deg);
  }

  &.bottom {
    transform: rotate(90deg);
  }

  svg {
    stroke-width: 1.5;
    color: ${props => props.color || props.theme.baseBlue.a6};
  }
`;

const LinkTxt = styled.span`
  font-size: 0.8rem;
  line-height: 1.467rem;
  letter-spacing: 0.3px;
  text-align: left;
  margin-left: 10px;
  white-space: nowrap;
  font-weight: 600;
`;

const NavArrowLnkSC = styled.div<{ $color?: string; $hoverColor?: string }>`
  font-size: 0.8rem;
  text-transform: uppercase;
  line-height: 1.467rem;
  text-align: left;
  display: flex;
  cursor: pointer;
  align-items: center;
  color: ${props => props.$color || props.theme.baseBlue.a6};

  &.arr-on-right {
    ${ArrowIcon} {
      order: 1;
    }

    ${LinkTxt} {
      margin-left: 0;
      margin-right: 10px;
    }
  }

  &:hover,
  &:hover svg {
    ${({ $hoverColor }) => `color: ${$hoverColor};`}
  }
`;

interface Props {
  arrowDir?: 'left' | 'right' | 'top' | 'bottom';
  arrOnRight?: boolean;
  hoverColor?: string;
  color?: string;
  children: ReactNode;
  viewBoxWidth?: number;
}

const NavArrowLnk: FC<Props> = ({ arrowDir = 'left', hoverColor, color, children, viewBoxWidth }) => (
  <NavArrowLnkSC className={arrowDir === 'right' ? 'arr-on-right' : ''} $hoverColor={hoverColor} $color={color}>
    <ArrowIcon name="iconArrow" className={arrowDir} color={color} viewBoxWidth={viewBoxWidth} />
    <LinkTxt>{children}</LinkTxt>
  </NavArrowLnkSC>
);

export default NavArrowLnk;
